import { useMemo, useSyncExternalStore } from "react";

const useQueryParams = () => {
  // Subscribe to changes in the URL
  const subscribe = (callback) => {
    window.addEventListener("popstate", callback);
    window.addEventListener("pushstate", callback);
    window.addEventListener("replacestate", callback);
    return () => {
      window.removeEventListener("popstate", callback);
      window.removeEventListener("pushstate", callback);
      window.removeEventListener("replacestate", callback);
    };
  };

  // Get the current search string
  const getSnapshot = () => window.location.search;

  const search = useSyncExternalStore(subscribe, getSnapshot, getSnapshot);

  return useMemo(() => {
    const params = new URLSearchParams(search);
    const queryMap = new Map();

    params.forEach((value, key) => {
      queryMap.set(key, value);
    });

    return queryMap;
  }, [search]);
};

export default useQueryParams;